module.exports = __webpack_public_path__ + "static/img/4.c906465a.png";